<div ngbDropdown container="body">
    <span class="rounded-circle" id="dropdownButton" ngbDropdownToggle>
        <i class="fa fa-ellipsis-v" aria-hidden="true"></i>
    </span>
    <div ngbDropdownMenu aria-labelledby="dropdownButton">
        <ng-content select=".dropdown-item"></ng-content>
    </div>
</div>
